module.exports = __webpack_public_path__ + "img/2025special_02.c5ba376f.jpg";